<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="冰排编号/调度订单编号/冷藏箱编号搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-allow="'actAdd'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', { type: 'add' })"
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
            <b-button
              size="sm"
              v-allow="'actPrint'"
              variant="outline-success"
              class="ml-2"
              @click="batchDetailPrint"
            >
              <i class="el-icon-printer"></i>
              批量打印
            </b-button>
            <b-button
              v-allow="'actImport'"
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="openImportPage"
            >
              <b-icon-cursor></b-icon-cursor>导入
            </b-button>
            <b-button
              v-allow="'actExport'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportData"
            >
              <b-icon-download></b-icon-download>
              导出
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户单号">
              <el-input
                v-model="form.bizBillNo"
                placeholder="请输入客户单号"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运单编号">
              <el-input
                v-model="form.waybillNo"
                placeholder="请输入运单编号"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="原订单编号">
              <el-input
                v-model="form.orderNo"
                placeholder="请输入原订单编号"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="调度订单编号">
              <el-input
                v-model="form.dispatchOrderNo"
                placeholder="请输入调度订单编号"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入柜操作人">
              <el-input
                v-model="form.inFreezerOptByName"
                placeholder="请输入入柜操作人"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出柜操作人">
              <el-input
                v-model="form.outFreezerOptByName"
                placeholder="请输入出柜操作人"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="创建人名字">
              <el-input
                v-model="form.createByName"
                placeholder="请输入创建人名字"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改人名字">
              <el-input
                v-model="form.modifyByName"
                placeholder="请输入修改人名字"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="入柜时间">
            <el-col :span="10">
              <el-date-picker
                v-model="form.inFreezerBeginTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="4">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="form.inFreezerEndTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="出柜时间">
            <el-col :span="10">
              <el-date-picker
                v-model="form.outFreezerBeginTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="4">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="form.outFreezerEndTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="创建时间">
            <el-col :span="10">
              <el-date-picker
                v-model="form.createBeginTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="4">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="form.createEndTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="修改时间">
            <el-col :span="10">
              <el-date-picker
                v-model="form.modifyBeginTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="4">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="form.modifyEndTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="可用状态">
              <el-checkbox-group v-model="form.icechopsStatus">
                <el-checkbox label="Y" name="type">有效</el-checkbox>
                <el-checkbox label="N" name="type">无效</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="在柜状态">
              <el-checkbox-group v-model="form.inFreezerStatusList">
                <el-checkbox label="L">在库</el-checkbox>
                <el-checkbox label="I">预冷</el-checkbox>
                <el-checkbox label="O">释冷</el-checkbox>
                <el-checkbox label="T">在途</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  icechopsStatus: ['Y'],
  inFreezerStatusList: [],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()

    let _this = this
    this.$eventBus.$on('customerGateTableReload', function() {
      _this.query()
    })
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    //批量打印
    batchDetailPrint() {
      this.$emit('batchDetailPrint')
    },
    //打开导入页面
    openImportPage() {
      this.$router.push({
        name: 'master-icechops-import',
      })
    },
    exportData() {
      let url = '/master/icechops/export'
      let fileName = '冰排信息'
      this.$api.globalExportData(url, this.form, fileName)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
